module.exports = __webpack_public_path__ + "img/Newbie_Bow_02_Classic.a363237d.png";